export default __webpack_public_path__ + "static/game-intro-03-ae02ad3851546ffbc170566b84fdbba1.png";